/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/type-annotation-spacing */

import { Component, OnInit, Inject, HostBinding } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation-modal.component';
import { MaterialModalConfirmComponent } from '../material-modal-confirm/material-modal-confirm.component';
import { RestService } from '../rest.service';
import { setting } from '../../../../setting';
import { ItineraryService } from '../itinerary.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { MaterialModalAlertComponent } from '../material-modal-alert/material-modal-alert.component';
import { Router } from '@angular/router';
import { AgentsService } from 'app/agents/agents.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FidelityService } from 'app/fidelity/fidelity.service';
import { Pax } from '../interfaz/pax';
import { NotificationService } from '../../shared/notifications/notification.service'

@Component({
  selector: 'usb-modal-post-booking',
  templateUrl: './modal-post-booking.component.html',
  styleUrls: ['./modal-post-booking.component.scss']
})
export class ModalPostBookingComponent implements OnInit {


  @HostBinding('style.--color-main-1') get color1() {
  return this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
}

@HostBinding('style.--color-main-2') get color2() {
  return this.getClientsSettingAppBooking?.clients_setting_global?.color_main_2;
}

  allItems:any = [];
  selectedItems:any = [];
  step = 1;

  totalPrice:any=0;
  leaveTotal:any;

  paymentMethods:any[] = [];
  details:any = [];

  agency:any;
  itinerary: any;
  totalPaymentPrice = 0;

  getClientsSettingAppBooking: any;
  creditCardPending = false;
  creditCardPayPartial = false;
  creditCardDataPending: any= [];
  amountCreditCard = 0;
  // Variable de almacenamiento de monto pendiente de pagos con tarjeta de credito pendiente
  amountFilterItineraryId: any = 0;
  amountFilterNull: any = 0;
  partialLeftCreditCard: any = 0;

  amountBLickoinsItineraryPay = 0;
  amountBLickoinsItineraryPayUSD = 0;
  amountBLickoinsItineraryPayAgency = 0;
  amountCardItineraryPay = 0;
  amountDepositItineraryPay = 0;
  amountDepositItineraryPayUSD = 0;
  amountDepositItineraryPayAgency = 0;
  amountTransferItineraryPay = 0;
  // Respuesta cruda de paymentMasters/listByItinerary/id: trae el detalle de pago
  // por producto (details[].uid) que no puede reconstruirse desde los acumulados.
  paymentMastersRaw: any[] = [];
  consultingPay = false;
  paymentSync = false;
  public currencyItinerary: string;
  type = '';
  payloadBillingRequest: any;
  payloadBillingRequestInvalid = true;
  applyFeeSelected = false;
  config = {
    backdrop: 'static',  // Evita el cierre al hacer clic fuera del modal
    keyboard: false,     // Desactiva el cierre con la tecla Escape
    class: 'modal-dialog-centered'
  };

  amountTransferItineraryPayAgency = 0;
  amountTransferItineraryPayUSD = 0;


  bsModalRef?: BsModalRef;
  fee = 0;
  alertMessagefee = false;
  selectedFeePayment = 0;
  currencies: any[] = [];
  currencyAgency: any;
  currencyPayment: any;
  paymentConditions: any;
  routerStorage: any;
  agencyLogotype = '';
  paymentRegister = false;
  itineraryPaxList: Pax[] = [];

    private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalPostBookingComponent>,
    public dialog:MatDialog,
    private _restService:RestService,
    private _itineraryService: ItineraryService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    public userService: UserService,
    private router: Router,
    private notificationService: NotificationService,
    private agentsService: AgentsService,
    private fidelityService: FidelityService

  ) {
  }

  ngOnInit() {
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.routerStorage = setting.apiStorageBooking;
    this.currencies = this.userService.currenciesExchange;

    this.variablesInitial();
    this.getPaymentConditions();
  }

    getPaymentConditions() {
    this._restService.doGet('app', 'agencyPaymentCondition/list?').subscribe({
      next: (response: any) => {
        if(response) {
          this.paymentConditions = response;
          this.setProductsTypes();
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log('No existe informacion, Condición de Pagos!', error);
      }
    })
  }

/**
 * Método para inicializar variables locales.
 *
 * Este método obtiene datos almacenados en `localStorage` y los inicializa en variables
 * locales para ser usados posteriormente.
 *
 * @property {any[]} getClientsSettingAppBooking - Configuración de clientes obtenida del almacenamiento local.
 * @property {any[]} allItems - Lista de todos los elementos inicializada como un arreglo vacío.
 * @property {any[]} paymentMethods - Métodos de pago inicializados como un arreglo vacío.
 * @property {any} itinerary - Datos del itinerario provenientes de `this.data.itinerary`.
 * @property {string} type - Tipo de operación definida en `this.data.type`.
 * @property {any} agency - Agencia seleccionada obtenida del almacenamiento local.
 * @property {string} currencyItinerary - Moneda del itinerario.
 */
variablesInitial(): void {
  this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
  this.allItems = [];
  this.paymentMethods = [];
  this.itinerary = this.data.itinerary;
  this.itineraryPaxList = this.itinerary.paxList || [];
  this.type = this.data.type;
  this.agency = JSON.parse(localStorage.getItem('selectedAgency'));
  // Para un guest recién creado, agencyShow() (guest bootstrap) puede no haber
  // resuelto todavía selectedAgency cuando este modal se abre — no reventar.
  this.currencyAgency = this.currencies.find(c => c.code === this.agency?.currency);
  this.currencyPayment = this.currencyAgency?.code;
  this.currencyItinerary = this.itinerary.currency;
  this.agencyLogotype = `${this.agency?.imagen_logotype}`;
  if(!this.currencyAgency && !this.userService._isGuest) {
      this.router.navigateByUrl('home');
      this.notificationService.warning('Moneda no configurada en la agencia');
    }
}

/**
 * Método para configurar los tipos de productos.
 *
 * Este método filtra los elementos del itinerario según el tipo especificado (`payment` o `request-billed`).
 * También realiza llamadas a métodos adicionales para obtener información relacionada con los elementos filtrados.
 *
 * @void
 */
setProductsTypes(): void {
  if (this.userService._isGuest && this.type === 'payment') {
    // Guest: no hay reserva previa cuyos items ya estén en status_id === 2
    // (approve) para elegir qué pagar — se paga y reserva el itinerario
    // completo de una vía paymentMasters/pay-reservate, así que se saltan la
    // selección (paso 1) y confirmación (paso 2) y se va directo a pagar.
    this.allItems = [...this.itinerary.items];
    this.selectedItems = [...this.itinerary.items];
    this.setPriceTotal();
    this.step = 3;
    return;
  }
  if (this.type === 'payment') {
    for (let i = 0; i < this.itinerary.items.length; i++) {
      this.itinerary.items[i].selected = false;

      if (
        this.itinerary.items[i].status_id === 2 &&
        !this.itinerary.items[i].isPendigApprovePay &&
        !this.itinerary.items[i].isPaidAgency &&
        !this.itinerary.items[i].isPaidProvider &&
        !this.itinerary.items[i].isBilled &&
        this.itinerary.items[i].source === 'Web'
      ) {
        this.allItems.push(this.itinerary.items[i]);
        this.getPaymentCreditCards();
      }
    }

    if (this.allItems.length === 0) {
      // this.dialogRef.close(false);
    }

    this.paymentMasterById(this.itinerary.id);
  } else if (this.type === 'request-billed') {
    for (let i = 0; i < this.itinerary.items.length; i++) {
      this.itinerary.items[i].selected = false;

      if (this.itinerary.items[i].isPaidAgency === true &&
          this.itinerary.items[i].idAbaco !== null &&
          this.itinerary.items[i].isReceipts === 1 &&
          this.itinerary.items[i].isBilled === false // para pruebas retirar este
      ) {
        this.allItems.push(this.itinerary.items[i]);
      }
    }
    // this.totalPrice = this.allItems.reduce()
  }
}

/**
 * Método para cambiar el paso actual en la interfaz.
 *
 * @param {number} step - El número del paso al que se desea cambiar.
 */
changeStep(step: number): void {
  this.step = step;
}

/**
 * Método para manejar la selección de un elemento.
 *
 * Si el elemento ya está en la lista de seleccionados, se elimina. Si no está, se agrega.
 * Finalmente, recalcula el precio total.
 *
 * @param {any} item - Elemento que se va a manejar.
 */
handleItem(item: any): void {
  let itemFound = this.selectedItems.find(element => element.id === item.id);
  if (itemFound) {
    let index = this.selectedItems.indexOf(itemFound);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    }
  } else {
    this.selectedItems.push(item);
  }
  this.setPriceTotal();
}

/**
 * Método para calcular y establecer el precio total.
 *
 * Este método suma los precios netos de todos los elementos seleccionados
 * y redondea el resultado a dos decimales.
 */
setPriceTotal(): void {
  this.totalPrice = 0;
  let price = 0;
  const paymentMethods = this.paymentConditions.find(c => c.id === this.agency?.pay_mode);
  this.selectedItems.forEach(element => {

    const itemCurrencyBase = this.currencies.find(c => c.code === element.currency);

    if(!itemCurrencyBase) {
      this.notificationService.warning(`El item ${element.title} no tiene una moneda asignada`);
      return;
    }

          if((element?.addonsIncluded && element?.addonsIncluded.length > 0) ||
         (element?.amenitiesIncluded && element?.amenitiesIncluded.length > 0)) {

       let additionalPaymentOffice = 0;
       let addonsIncludedPaymentOffice: any[] = [];

       if(element?.addonsIncluded && element?.addonsIncluded.length > 0) {
        addonsIncludedPaymentOffice = element?.addonsIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       } else if(element?.amenitiesIncluded && element?.amenitiesIncluded.length > 0) {
        addonsIncludedPaymentOffice = element?.amenitiesIncluded.filter(c => c.PaymentOffice === true || c.paymentOffice === true);
       }

      additionalPaymentOffice = addonsIncludedPaymentOffice.reduce((total, addon) => {

        let priceProf = 0;

        switch(element.category_id) {
          case 1: // Hotel
            priceProf =  total + ((addon.price || 0) * (addon.qtyOptional || 1));
            break;
          case 2: // Rent a car
            priceProf =  total + ((addon.totalNetPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 6: // Tour
            priceProf =  total + ((addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
          case 8: // Traslado
            priceProf =  total + (addon?.totalPrice || 0);
            break;
          case 9: // Ticket
            priceProf =  total + ((addon.totalPriceProf || 0) * (addon.qtyOptional || 1));
            break;
        }

        return total + (priceProf || 0);
      }, 0);

      if(additionalPaymentOffice > 0) {
        price = element.netPriceBooking - additionalPaymentOffice;
      } else {
        price = element.netPriceBooking;
      }
    } else {
      price = element.netPriceBooking;
    }

    let elementBaseRate = price / itemCurrencyBase.rate;

    elementBaseRate = elementBaseRate * this.currencyAgency?.rate;

    this.totalPrice += parseFloat(elementBaseRate.toString());

    if(!element.feePayment) {
      this.fee += parseFloat(element.fee);
    }
  });

  this.totalPrice = Math.round(this.totalPrice * 100) / 100;
}

applyFee(apply: boolean): void {
  if(apply) {
    this.applyFeeSelected = true;
    this.totalPrice += this.fee;
  } else {
    this.applyFeeSelected = false;
    this.totalPrice -= this.fee;
  }
}

/**
 * Método para cerrar el modal principal.
 *
 * Este método muestra un modal de confirmación para asegurarse de que el usuario desea cerrar.
 * Si el usuario confirma, cierra el modal y, si el paso actual es 4, emite un evento
 * para notificar la actualización de pagos.
 *
 * @modalService-> Servicio para manejar la apertura de modales.
 * @bsModalRef: ModalRef-> Referencia al modal actualmente abierto.
 * @dialogRef: MatDialogRef-> Referencia al modal de diálogo a cerrar.
 * @confirmSubscription: Subscription-> Suscripción para manejar el resultado de confirmación del usuario.
 * @step: number-> Paso actual en el flujo.
 */
close(): void {
  const initialState: ModalOptions = {
    initialState: {
      message: '¿Estás seguro de cerrar?'
    }
  };

  this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);

  const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
    if (result) {
      this.fee = 0;
      this.applyFeeSelected = false;
      this.dialogRef.close(true);


      // Emitir el evento solo si el paso actual es 4
      if (this.step === 4) {
        this._itineraryService.emitCloseModalPaymentUpdate(); // Emitir el evento
      }
    } else {
      // Acción opcional si se cancela la confirmación
      // this.openModalExtraLarge(templateNewClient);
    }
  });
}

/**
 * Método para cerrar el modal superior.
 *
 * Similar al método `close`, pero cierra el modal de diálogo con un valor `false`.
 * Si el usuario confirma, cierra el modal y, si el paso actual es 4, emite un evento
 * para notificar la actualización de pagos.
 *
 * @modalService-> Servicio para manejar la apertura de modales.
 * @bsModalRef: ModalRef-> Referencia al modal actualmente abierto.
 * @dialogRef: MatDialogRef-> Referencia al modal de diálogo a cerrar.
 * @confirmSubscription: Subscription-> Suscripción para manejar el resultado de confirmación del usuario.
 * @step: number-> Paso actual en el flujo.
 */
closeTop(): void {
  const initialState: ModalOptions = {
    initialState: {
      message: '¿Estás seguro de cerrar?'
    }
  };

  this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);

  const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
    if (result) {
      this.fee = 0;
      this.applyFeeSelected = false;
      this.dialogRef.close(false);

      // Emitir el evento solo si el paso actual es 4
      if (this.step === 4) {
        this._itineraryService.emitCloseModalPaymentUpdate(); // Emitir el evento
      }
    } else {
      // Acción opcional si se cancela la confirmación
      // this.openModalExtraLarge(templateNewClient);
    }
  });
}

/**
 * Método para retroceder un paso en el flujo.
 *
 * Este método actualiza el estado del paso actual (`step`) y, si el paso es 2,
 * resetea la selección de elementos y el precio total.
 *
 * @step: number -> Representa el paso actual en el flujo.
 * @selectedItems: any[] -> Arreglo de elementos seleccionados.
 * @totalPrice: number -> Precio total calculado.
 * @allItems: any[] -> Lista de todos los elementos disponibles.
 */
goBack(): void {
  if (this.step == 2) {
    this.selectedItems = [];
    this.totalPrice = 0;
    this.allItems.forEach(element => {
      element.selected = false;
    });
  }
  if (this.step == 3) {
    if(this.applyFeeSelected) {
      this.totalPrice -= this.fee;
      this.applyFeeSelected = false;
    }
  }
  this.step = this.step - 1;
}

/**
 * Método para verificar si se puede avanzar al siguiente paso.
 *
 * Evalúa el estado actual basado en el valor de `step` y determina si es posible
 * continuar al siguiente paso en el flujo.
 *
 * @step: number -> Paso actual.
 * @selectedItems: any[] -> Arreglo de elementos seleccionados.
 * @paymentMethods: any[] -> Métodos de pago disponibles.
 * @leaveTotal: number -> Total restante para pagos.
 * @returns: boolean -> `true` si no se puede avanzar, `false` si es posible continuar.
 */
verifyNext(): boolean {
  switch (this.step) {
    case 1:
      if (this.selectedItems.length > 0) {
        return false;
      } else {
        return true;
      }

    case 3:

    if(this.type === 'payment') {
      const paymentCardSuccess = this.paymentMethods.find(element => element.id == 2);
      if (this.leaveTotal === 0 || paymentCardSuccess) {
        const aux = this.paymentMethods.find(element => element.error == true);
        return !!aux;
      } else {
        return true;
      }
    }
    if(this.type === 'request-billed') {
      if(!this.payloadBillingRequestInvalid) {
        return false;
      } else {
        return true;
      }
    }

    default:
      break;
  }
}

/**
 * Método para avanzar al siguiente paso en el flujo.
 *
 * Dependiendo del paso actual (`step`), realiza acciones específicas:
 * - Paso 3: Muestra un modal de confirmación para registrar transacciones de pago.
 * - Otros pasos: Simplemente incrementa el valor de `step`.
 *
 * @step: number -> Paso actual.
 * @paymentMethods: any[] -> Métodos de pago disponibles.
 * @paymentSync: boolean -> Estado de sincronización del pago.
 * @bsModalRef: ModalRef -> Referencia al modal actualmente abierto.
 * @spinner: NgxSpinnerService -> Servicio para mostrar y ocultar el spinner de carga.
 * @setItemDetails(): void -> Método para configurar detalles de los ítems seleccionados.
 * @savePayments(): void -> Método para guardar los pagos registrados.
 */
next(): void {
  switch (this.step) {
    case 3:


    if(this.type === 'payment') {
      let dataModal: any;

      if(this.alertMessagefee) {
          const initialState: ModalOptions = {
                  initialState: {
                   data: 'Debe pagar el fee en antes de continuar'
                  }
                };
          const modalOptions = Object.assign({}, initialState, this.config);
          this.bsModalRef = this.modalService.show(MaterialModalAlertComponent, modalOptions);

      } else {
        if(this.paymentMethods && this.paymentMethods.length > 0) {
          dataModal = { payment: this.paymentMethods, feePayment : this.selectedFeePayment};
        }

        const initialState: ModalOptions = {
          initialState: {
            paymentModal: dataModal,
            currencyItinerary: this.currencyPayment
          }
        };

        this.bsModalRef = this.modalService.show(MaterialModalConfirmComponent, initialState);

        const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
          // this.spinner.show();
          this.paymentRegister = true;
          if (result) {
            this.paymentSync = true;
            // Si es el paso 3 de pago, registra la transacción
            this.setItemDetails();
            this.savePayments();
          } else {
            this.paymentSync = false;
            this.paymentRegister = false;
            // this.spinner.hide();
            return;
          }
        });
      }
    }
    if(this.type === 'request-billed') {

      const initialState: ModalOptions = {
        initialState: {
          message: 'Enviar a facturar'
        }
      };

      this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);

      const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {

        if(result) {
          this.paymentRegister = true;
          this._restService.doPost('app', 'billingRequest/create', this.payloadBillingRequest).subscribe({
            next: (res: any) => {
              this.paymentRegister = false;
              this.step = this.step + 1;
          },
            error: (error: HttpErrorResponse) => {

              this.paymentRegister = false;
            }
          })
        }
      });
    }
      break;

    default:
      // Cambia al siguiente paso
      this.step = this.step + 1;
      break;
  }
}

/**
 * Método para configurar los detalles de los ítems seleccionados.
 *
 * Este método recopila información relevante de los ítems seleccionados y la almacena
 * en la propiedad `details`. Solo se ejecuta si no hay pagos pendientes o parciales con tarjeta de crédito.
 *
 * @creditCardPending: boolean -> Indica si hay pagos pendientes con tarjeta de crédito.
 * @creditCardPayPartial: boolean -> Indica si hay pagos parciales con tarjeta de crédito.
 * @details: any[] -> Arreglo donde se almacenan los detalles de los ítems seleccionados.
 * @selectedItems: any[] -> Lista de ítems seleccionados.
 */
setItemDetails(): void {
  if (!this.creditCardPending && !this.creditCardPayPartial) {

    const currencySelected = this.currencies.find(c => c.code === this.currencyPayment);
    this.details = [];

    if(currencySelected) {

      this.selectedItems.forEach(element => {

        const amountBase = this.currencies.find(c => c.code === element.currency);
        const netPriceBookingBase = element.netPriceBooking / amountBase.rate;
        const amount_payment = this.currencyPayment !== this.currencyAgency.code ? netPriceBookingBase :  element.netPriceBooking * this.currencyAgency.rate;

        this.details.push({
          category_id: element.category_id,
          id: element.id,
          currency_payment: this.currencyPayment,
          amount_payment: amount_payment,
          amount: element.netPriceBooking, // totalPrice
          amount_historic_payment: {
          exchange_rate: parseFloat(Number(this.currencyAgency.rate).toFixed(2)),
          converted_amounts: {
                    fee: parseFloat(Number(element.fee * this.currencyAgency.rate).toFixed(2)),
                    netPriceAgent: parseFloat(Number(element.netPriceAgent * this.currencyAgency.rate).toFixed(2)),
                    netPriceBooking: parseFloat(Number(element.netPriceBooking * this.currencyAgency.rate).toFixed(2)),
                    taxPrice: parseFloat(Number(element.taxNightsPriceTotal * this.currencyAgency.rate).toFixed(2)),
                    netPriceBookingFreeTax: element.taxNightsPriceTotal > 0 ? parseFloat(Number(element.netPriceBookingFreeTax * this.currencyAgency.rate).toFixed(2)) : parseFloat(Number(element.netPriceBooking * this.currencyAgency.rate).toFixed(2)),
                    netPriceProvider: parseFloat(Number(element.profility.netPriceProvider * this.currencyAgency.rate).toFixed(2)),
                    netPriceCategory: parseFloat(Number(element.profility.netPriceCategory * this.currencyAgency.rate).toFixed(2)),
                    rate_timestamp: new Date(),
                    cancellation_policies: this.getCancellationPolicies(element.category_id, element),
                    extras: this.getServiceExtrasConverted(element),
                  }
                }
        });
      });

    }
  }

}

getServiceExtrasConverted(product: any): any[] {

  // Validar que currencyAgency existe
  if (!this.currencyAgency || !this.currencyAgency.rate) {
    console.error('currencyAgency o rate no definido');
    return product.serviceExtra; // Retorna sin conversión
  }

       let addonsIncludedPaymentOffice: any[] = [];

       if(product?.addonsIncluded && product?.addonsIncluded.length > 0) {
        addonsIncludedPaymentOffice = product?.addonsIncluded.filter(c => c.PaymentOffice === false || c.paymentOffice === false);
       } else if (product?.amenitiesIncluded && product?.amenitiesIncluded.length > 0) {
        addonsIncludedPaymentOffice = product?.amenitiesIncluded.filter(c => c.PaymentOffice === false || c.paymentOffice === false);
       } else {
          return [];
       }

      return addonsIncludedPaymentOffice.map((extra: any) => ({
        ...extra,
        priceAmountPayment: parseFloat(Number(this.getPriceAmountPaymentExtras(extra, product?.currency, product?.category_id)).toFixed(2)),
      }));
}

    getPriceAmountPaymentExtras(extra: any, currency: string, categoryId: number): number {
            if (!extra) {
              return 0;
            }

            const baseRate = this.currencies.find(c => c.code === currency)?.rate || 1;
            let priceExtra = 0;
            let priceProf = 0;

            switch(categoryId) {
              case 1: // Hotel
                priceProf =  ((extra?.price || 0) / baseRate) * this.currencyAgency.rate;
                break;
              case 2: // Rent a car
                priceProf =  ((extra?.totalNetPriceProf || 0) / baseRate) * this.currencyAgency.rate;
                break;
              case 6: // Tour
                priceProf =  ((extra?.totalPriceProf || 0) / baseRate) * this.currencyAgency.rate;
                break;
              case 8: // Traslado
                priceProf =  ((extra?.totalPrice || 0) / baseRate) * this.currencyAgency.rate;
                break;
              case 9: // Ticket
                priceProf =  ((extra?.totalPriceProf || 0) / baseRate) * this.currencyAgency.rate;
                break;
            }

            priceExtra = priceProf;

            return priceExtra;
    }


getCancellationPolicies(category, item): any {
   const currentDate = new Date();
    const defaultPolicy = {
        currency: this.currencyAgency?.code,
        from: currentDate,
        amount: 0,
        apply: false
    };

    // Determinar el array de políticas según la categoría
    let policies = [];
    if (category === 1) {
        policies = item.room?.cancellationPolicy || [];
    } else if (category === 8) {
        policies = item.cancellationPolicies || [];
    }

    // Si no hay políticas, retornar el default
    if (policies.length === 0) {
        return [defaultPolicy];
    }

    // Ordenar políticas por fecha 'from'
    const sortedPolicies = [...policies].sort((a, b) =>
        new Date(a.from).getTime() - new Date(b.from).getTime()
    );

    // Encontrar la política aplicable
    let applicableIndex = -1;
    for (let i = 0; i < sortedPolicies.length; i++) {
        if (new Date(sortedPolicies[i].from) <= currentDate) {
            applicableIndex = i;
        } else {
            break;
        }
    }
    // Preparar el resultado con el campo apply
    const result = sortedPolicies.map((policy, index) => {
      const baseRate = this.currencies.find(c => c.code === policy.currency)?.rate || 1;
      const targetRate = this.currencyAgency?.rate || 1;

        const isApplicable = index === applicableIndex;
        const amount = (policy.amount / baseRate) * targetRate;

        return {
            ...policy,
            currency: this.currencyAgency?.code,
            amount: amount,
            apply: isApplicable
        };
    });

    // Si no hay ninguna aplicable y hay políticas, marcamos todas como no aplicables
    if (applicableIndex === -1 && result.length > 0) {
      const targetRate2 = this.currencyAgency?.rate || 1;
      return result.map(policy => ({
            ...policy,
            currency: this.currencyAgency?.code,
            amount: (policy.amount / this.currencies.find(c => c.code === policy.currency)?.rate) * targetRate2,
            apply: false
        }));
    }

    return result;
}

/**
 * Método para guardar los pagos realizados.
 *
 * Este método crea un objeto con los métodos de pago seleccionados y sus respectivos detalles,
 * luego realiza una solicitud HTTP para enviar la información al backend.
 *
 * @paymentMethods: any[] -> Lista de métodos de pago seleccionados.
 * @agency: { agent_id: number, agency_id: number } -> Información de la agencia.
 * @itinerary: { id: number } -> Información del itinerario.
 * @currencyItinerary: string -> Moneda asociada al itinerario.
 * @details: any[] -> Detalles de los ítems seleccionados.
 * @spinner: NgxSpinnerService -> Servicio para mostrar y ocultar el spinner de carga.
 * @step: number -> Paso actual del flujo.
 * @paymentMasterById(id: number): void -> Método para obtener información de pagos por ID.
 * @doPost(endpoint: string, route: string, data: any): Observable<any> -> Método para realizar solicitudes POST.
 */
savePayments(): void {
  const data = {
    paymentMethods: []
  };

  // Filtra métodos de pago con montos válidos
  this.paymentMethods = this.paymentMethods.filter(payment => payment.amount !== null);

  // Construye la estructura de datos para cada método de pago
  this.paymentMethods.forEach(element => {


    const detailsCopy = this.details.map(detail => {
      // Crear una copia de cada detalle con el amount_payment asignado
      return {
        ...detail,
        amount_payment: element.amount // Asignar el amount correspondiente
      };
    });

    let elementAmount = 0;
    // El monto se ingresó en this.currencyPayment (la moneda de la sesión de pago),
    // no en element.currency: los métodos de pago no traen su propia moneda.
    const amountCurrency = this.currencyPayment === 'USD';

    if(amountCurrency) {
       elementAmount = element.amount;
    } else {
      const elementCurrencyRefer = this.currencies.find(c => c.code === this.currencyPayment);

      if(elementCurrencyRefer) {
        elementAmount = element.amount / elementCurrencyRefer?.rate;
      } else {
           elementAmount = element.amount;
      }

    }


    data.paymentMethods.push({
      payment_methods_id: element.id,
      total_amount: elementAmount.toFixed(2), // Base de dolar para guardar
      agent_id: this.agency.agent_id,
      agency_id: this.agency.agency_id,
      itinerary_id: this.itinerary.id,
      user_id_create: this.agency.agent_id,
      currency_payment: this.currencyPayment,
      amount_payment: element.amount,
      paymentMasterDetails: detailsCopy,
      currency: element.id === 3 ? this.currencyAgency?.code : 'USD',
      client_id: this.getClientsSettingAppBooking.id,
      fileArray: element.id == 4 ? element.filesArray : null,
    });
  });


  data.paymentMethods.forEach((method: any) => {

    if(method.payment_methods_id === 3) {
      if(method.currency_payment === 'USD') {
        method.currency_payment = this.currencyAgency?.code;
        method.amount_payment = method.amount_payment * this.currencyAgency?.rate;
      };


      method.paymentMasterDetails.forEach((detail: any) => {
        if(detail.currency_payment === 'USD') {
          detail.currency_payment = this.currencyAgency?.code;
          detail.amount_payment = detail.amount_payment * this.currencyAgency?.rate;
      };
      });
    }

  })



// this.spinner.hide();
  // Enviar la solicitud HTTP
  this._restService.doPost('app', 'paymentMasters/create', data).subscribe(
    (response: any) => {
      if (response.success) {
        // this.spinner.hide();
        this. setBalance();
        // Mantener el overlay de "registrando su pago" hasta tener los datos
        // frescos del paso 4 (paymentMasterById), para que el cambio de paso
        // 3 a 4 no muestre un hueco vacío mientras se consulta consultingPay.
        this.paymentMasterById(this.itinerary.id, () => {
          this.paymentRegister = false;
          this.step = this.step + 1;
        });
      } else {
        console.log("error al ejecutar endpoint payment Master");
        this.paymentRegister = false;
      }
    },
    error => {
      console.log("error");
      this.paymentRegister = false;
    }
  );
}

 setBalance() {
    let pass = false;
    let creditsBlickoins = 0;
    this._itineraryService.activeItinerary
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe({
      next: (data: any) => {
      pass = true;
      this.agentsService.getBalanceAgency(this.userService._agencyID, this.userService._agentID)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (response: any) => {
        this.userService.creditsDeposits = parseFloat(response.balanceCreditsDeposits) ? parseFloat(response.balanceCreditsDeposits) : 0;
        this.fidelityService.creditDepositActives = this.userService.creditsDeposits;
        this.userService.credits = parseFloat(response.balanceCredits) ? parseFloat(response.balanceCredits) : 0;
        this.userService.creditLimits = this.userService.credits + this.userService.creditsDeposits;
        if(response.agent) {
           this.userService.balanceBlickoins = parseFloat(response.agent?.availableBlickoins) ? parseFloat(response.agent?.availableBlickoins) : 0;
           this.userService.creditBlickoins = parseFloat(response.agent?.availableCreditBlickoins) ? parseFloat(response.agent?.availableCreditBlickoins) : 0;
        } else if(!response.agent) {
          this.setBalanceBlickoins();
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    });
    },
    error: (error: HttpErrorResponse) => {
      console.log(error)
    }
  });
  }

  setBalanceBlickoins(): void {

      this.agentsService.getBalanceAgent(this.userService._agentID)
      .subscribe({
        next: (response: any) => {
        this.userService.balanceBlickoins = response.availableBlickoins;
        this.userService.creditBlickoins = response.availableCreditBlickoins;

      },
      error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }

 /**
 * Maneja el cálculo y la actualización del monto total pendiente de pago (`leaveTotal`).
 *
 * Este método actualiza la propiedad `leaveTotal` a partir de los datos recibidos.
 * También filtra los métodos de pago con montos válidos (no nulos) y actualiza la lista
 * `paymentMethods`, asegurando que no se dupliquen y se mantengan actualizados los datos.
 *
 * @param data {any} - Objeto que contiene los datos de los métodos de pago y el monto auxiliar (`aux`).
 *   - `data.aux` {number} -> Monto total pendiente.
 *   - `data.paymentMethods` {Array<any>} -> Lista de métodos de pago a procesar.
 *
 * @property leaveTotal {number} - Monto total pendiente de pago.
 * @property paymentMethods {Array<any>} - Lista actualizada de métodos de pago.
 */
handleLeaveTotal(data: any): void {
  this.leaveTotal = data.aux;
  // Filtrar los métodos de pago con montos válidos (no nulos/indefinidos)
  const filteredPaymentMethods = data.paymentMethods.filter(
    (paymentMethod: any) => paymentMethod.amount !== null && paymentMethod.amount !== undefined
  );

  // Limpiar el array `this.paymentMethods`
  this.paymentMethods = [];

  // Iterar sobre los datos filtrados
  filteredPaymentMethods.forEach((paymentMethod: any) => {
    // Buscar si ya existe un objeto con el mismo ID en el array
    const existingIndex = this.paymentMethods.findIndex((item: any) => item.id === paymentMethod.id);

    // Actualizar o agregar el método de pago
    if (existingIndex !== -1) {
      this.paymentMethods[existingIndex] = paymentMethod; // Actualizar
    } else {
      this.paymentMethods.push(paymentMethod); // Agregar
    }
  });

}

/**
 * Verifica si una categoría específica está presente en los ítems seleccionados.
 *
 * Este método busca dentro de los ítems seleccionados (`selectedItems`) para determinar
 * si existe al menos un ítem con el nombre de categoría proporcionado.
 *
 * @param category {string} - Nombre de la categoría a verificar.
 *   Valores válidos: "HOTELS", "TOURS", "RENT-A-CAR", "TRANSPORTS", "PTHEMES", "CRUISES", "DISNEY".
 *
 * @returns {boolean} - Devuelve `true` si la categoría está presente, de lo contrario `false`.
 *
 * @property selectedItems {Array<any>} - Lista de ítems seleccionados donde se realiza la búsqueda.
 */
verifyCategory(category: string): boolean {
  let aux;

  switch (category) {
    case "HOTELS":
      aux = this.selectedItems.find(element => element.categoryName === 'HOTELS');
      return !!aux;

    case "TOURS":
      aux = this.selectedItems.find(element => element.categoryName === 'TOURS' && element.subCategoryId === 6);
      return !!aux;

    case "TICKETS":
      aux = this.selectedItems.find(element => element.categoryName === 'TOURS' && element.subCategoryId === 9);
      return !!aux;

    case "RENT-A-CAR":
      aux = this.selectedItems.find(element => element.categoryName === 'RENT-A-CAR');
      return !!aux;

    case "TRANSPORTS":
      aux = this.selectedItems.find(element => element.categoryName === 'TRANSPORTS');
      return !!aux;

    case "INSURANCE":
      aux = this.selectedItems.find(element => element.categoryName === 'INSURANCE');
      return !!aux;

    case "PTHEMES":
      aux = this.selectedItems.find(element => element.categoryName === 'PTHEMES');
      return !!aux;

    case "CRUISES":
      aux = this.selectedItems.find(element => element.categoryName === 'CRUISES');
      return !!aux;

    case "DISNEY":
      aux = this.selectedItems.find(element => element.categoryName === 'DISNEY');
      return !!aux;

    default:
      return false;
  }
}

/**
 * Verifica y cuenta la cantidad de ítems seleccionados pertenecientes a una categoría específica.
 *
 * Este método itera sobre la lista de ítems seleccionados (`selectedItems`) y cuenta cuántos ítems
 * pertenecen a la categoría proporcionada. Devuelve el número total de ítems encontrados.
 *
 * @param category {string} - Nombre de la categoría a verificar.
 *   Valores válidos: "HOTELS", "TOURS", "TRANSPORTS", "PTHEMES", "RENT-A-CAR", "CRUISES", "DISNEY".
 *
 * @returns {number} - Cantidad de ítems seleccionados que pertenecen a la categoría especificada.
 *
 * @property selectedItems {Array<any>} - Lista de ítems seleccionados donde se realiza la búsqueda.
 */
verifyQuantityCategory(category: string): number {
  let aux = 0;

  switch (category) {
    case "HOTELS":
      this.selectedItems.forEach(element => {
        if (element.categoryName === 'HOTELS') {
          aux++;
        }
      });
      break;

      case "TOURS":
        this.selectedItems.forEach(element => {
          if (element.categoryName == 'TOURS' && element.subCategoryId === 6) {
            aux++;
          };
        });
        break;

        case "TICKETS":
         this.selectedItems.forEach(element => {
          if (element.categoryName == 'TOURS' && element.subCategoryId === 9) {
            aux++;
          };
        });
        break;

    case "TRANSPORTS":
      this.selectedItems.forEach(element => {
        if (element.categoryName === 'TRANSPORTS') {
          aux++;
        }
      });
      break;

    case "INSURANCE":
      this.selectedItems.forEach(element => {
        if (element.categoryName === 'INSURANCE') {
          aux++;
        }
      });
      break;

    case "PTHEMES":
      this.selectedItems.forEach(element => {
        if (element.categoryName === 'PTHEMES') {
          aux++;
        }
      });
      break;

    case "RENT-A-CAR":
      this.selectedItems.forEach(element => {
        if (element.categoryName === 'RENT-A-CAR') {
          aux++;
        }
      });
      break;

    case "CRUISES":
      this.selectedItems.forEach(element => {
        if (element.categoryName === 'CRUISES') {
          aux++;
        }
      });
      break;

    case "DISNEY":
      this.selectedItems.forEach(element => {
        if (element.categoryName === 'DISNEY') {
          aux++;
        }
      });
      break;

    default:
      break;
  }

  return aux;
}


/**
 * Realiza una solicitud HTTP GET para obtener las tarjetas de crédito pendientes de pago y realiza
 * acciones basadas en la respuesta recibida.
 */
getPaymentCreditCards() {
  // Construye la URL para la solicitud HTTP GET
  const url = 'paymentCreditCards/listPending?' + this.itinerary.items[0].itinerary_id;

  // Realiza la solicitud HTTP GET al backend
  this._restService.doGet_('app', url).subscribe({
      next: (response: any) => {
          // Verifica si la respuesta contiene datos
          if (response.data.data.length > 0) {
              this.itinerary.items = this.itinerary.items.filter(c => c.status_id !== 5);
              // Filtra los elementos de this.allItems basándose en los datos de las tarjetas de crédito pendientes
              this.filterAllItemsWhitCreditCardPending(response.data.data);

              // Ejecuta una acción relacionada con las tarjetas de crédito pendientes
              this.questPaymentCreditCardPending(response.data.data);

          } else {

          }
      },
      error: (error: HttpErrorResponse) => {
          // Manejo de errores en caso de que ocurra un problema durante la solicitud
      }
  });
}

/**
 * Obtiene los detalles de los pagos asociados a un itinerario y actualiza las variables de montos totales por método de pago.
 *
 * Este método realiza una solicitud GET para obtener una lista de pagos relacionados con un itinerario específico.
 * Itera sobre los resultados para clasificar y acumular los montos de pago según el ID del método de pago.
 *
 * @param itineraryId {number} - ID del itinerario para el cual se recuperan los pagos.
 *
 * @returns {void}
 *
 * @property _restService {any} - Servicio que gestiona solicitudes HTTP en la aplicación.
 * @property amountBLickoinsItineraryPay {number} - Monto total de pagos realizados con BLIKCoins.
 * @property amountCardItineraryPay {number} - Monto total de pagos realizados con tarjeta de crédito.
 * @property amountDepositItineraryPay {number} - Monto total de pagos realizados con depósito.
 * @property amountTransferItineraryPay {number} - Monto total de pagos realizados con transferencia.
 * @property consultingPay {boolean} - Indicador para determinar si los datos de pago se han consultado correctamente.
 */
paymentMasterById(itineraryId: number, onComplete?: () => void): void {
  const url = 'paymentMasters/listByItinerary/' + itineraryId;

  // Reiniciar acumuladores: este método puede llamarse más de una vez (al abrir
  // el modal y luego de registrar un pago nuevo) y la respuesta trae siempre el
  // listado completo, así que sin resetear se duplicarían los montos ya sumados.
  this.amountBLickoinsItineraryPay = 0;
  this.amountBLickoinsItineraryPayUSD = 0;
  this.amountBLickoinsItineraryPayAgency = 0;
  this.amountCardItineraryPay = 0;
  this.amountDepositItineraryPay = 0;
  this.amountDepositItineraryPayUSD = 0;
  this.amountDepositItineraryPayAgency = 0;
  this.amountTransferItineraryPay = 0;
  this.amountTransferItineraryPayUSD = 0;
  this.amountTransferItineraryPayAgency = 0;

  this._restService.doGet('app', url).subscribe({
    next: (response: any) => {
      // Guardar la respuesta cruda para poder mostrar el pago por producto individual
      this.paymentMastersRaw = response || [];

      // Validar la respuesta y procesar si contiene datos
      if (response && response.length > 0) {
        response.forEach((item, index) => {
          // Clasificar y acumular montos por método de pago
          switch (item.payment_methods_id) {
            case 1: // BLIKCoins
              this.amountBLickoinsItineraryPay += Number(item.total_amount);
              if(item.details[0]) {
                if(item.details[0].currency_payment === 'USD') {
                  this.amountBLickoinsItineraryPayUSD += Number(item.details[0].amount_payment);
                } else {
                  this.amountBLickoinsItineraryPayAgency += Number(item.details[0].amount_payment);
                }
              }
              break;

            case 2: // Tarjeta de crédito
              this.amountCardItineraryPay += Number(item.details[0].amount_payment);
              break;

            case 3: // Depósito
              this.amountDepositItineraryPay += Number(item.total_amount);
              if(item.details[0]) {
                if(item.details[0].currency_payment === 'USD') {
                  this.amountDepositItineraryPayUSD += Number(item.details[0].amount_payment);
                } else {
                  this.amountDepositItineraryPayAgency += Number(item.details[0].amount_payment);
                }
              }
              break;

            case 4: // Transferencia
              if(item.details[0]) {
                if(item.details[0].currency_payment === 'USD') {
                  this.amountTransferItineraryPayUSD += Number(item.details[0].amount_payment);
                } else {
                  this.amountTransferItineraryPayAgency += Number(item.details[0].amount_payment);
                }
              }
              this.amountTransferItineraryPay += Number(item.total_amount);
              break;
          }
        });
      }

      // Se marca como consultado siempre que la petición responda, haya o no
      // pagos, para no dejar el paso 4 esperando indefinidamente por consultingPay.
      this.consultingPay = true;
      onComplete?.();
    },
    error: (error: HttpErrorResponse) => {
      console.log(error); // Manejo de errores en la solicitud HTTP
      onComplete?.();
    }
  });
}

private filterAllItemsWhitCreditCardPending(creditCardData: any) {
  // PASO 1: Ignorar completamente pagos de otras agencias

  const sameAgencyPayments = creditCardData.filter(payment =>
    payment.agency_id === this.itinerary.agency_id
  );

  // PASO 2: Buscar pagos pendientes válidos (misma agencia, no status 5)
  let validPendingPayments = sameAgencyPayments.filter(payment =>
    payment.payment_masters_id === null
  );

  // SCENARIO A: No hay pagos pendientes de interés - filtrar normalmente
  if (validPendingPayments.length === 0) {
    this.filterNormalItems(sameAgencyPayments);
    return;
  }

  // SCENARIO B: Hay pagos pendientes de la misma agencia
  this.handlePendingPaymentsScenario(validPendingPayments);
}

private filterNormalItems(sameAgencyPayments: any[]) {
  const idsToFilter = sameAgencyPayments.map(payment => Number(payment.details[0].uid));

  this.allItems = this.allItems.filter(item =>
    !idsToFilter.includes(item.id)
  );
}

private handlePendingPaymentsScenario(pendingPayments: any[]) {
  const pendingThisItinerary = pendingPayments.find(payment =>
    payment.itinerary_id === this.itinerary.id
  );

  if (pendingThisItinerary) {
    // Pendiente en ESTE itinerario
    this.notificationService.warning('Tiene registro de pago pendiente.', 'Pago Pendiente');

    const pendingIds = pendingPayments
      .filter(payment => payment.itinerary_id === this.itinerary.id)
      .map(payment => Number(payment.details[0].uid));

    this.allItems = this.allItems.filter(item => pendingIds.includes(item.id));
  } else {
    // Pendiente en OTRO itinerario de la misma agencia
    const otherItineraryId = pendingPayments[0].itinerary_id;
    this.notificationService.warning(
      `Pago pendiente en itinerario ${otherItineraryId}. Cierre el pago allí primero.`);

    this.fee = 0;
    this.applyFeeSelected = false;
    this.dialogRef.close(true);
  }
}

// /**
//  * Filtra los elementos de this.allItems basándose en los datos de las tarjetas de crédito pendientes recibidas.
//  * @param creditCardData Datos de las tarjetas de crédito pendientes.
//  */
// private filterAllItemsWhitCreditCardPending(creditCardData: any) {

//   const idsToFilter = [];
// console.log(creditCardData)
//   creditCardData.forEach((payment) => {
//       idsToFilter.push(Number(payment.details[0].uid));
//   });
// console.log(this.allItems)
//   this.allItems = this.allItems.filter(item => idsToFilter.indexOf(item.id) !== -1);
// console.log(this.allItems)
// }


// private filterAllItemsWhitCreditCardPending(creditCardData: any) {
//   // Arreglo temporal para almacenar los ID a filtrar
//   const idsToFilter = [];

//   // Recorre los datos de las tarjetas de crédito pendientes y agrega los IDs al arreglo temporal
//   creditCardData.forEach((payment) => {
//       idsToFilter.push(payment.details[0].uid); // Agregar el ID al arreglo temporal
//   });

//   // Filtra this.allItems una sola vez utilizando los ID almacenados en idsToFilter
//   this.allItems = this.allItems.filter(item => !idsToFilter.includes(item.id.toString()));
// }


  /**
   * Filtra los datos de los pagos con tarjeta de crédito pendientes para el itinerario actual.
   * Actualiza la variable 'paymentCreditCards' con los datos recibidos y filtra los pagos
   * que coinciden con el ID del itinerario y que aún no tienen un ID de maestro de pago asignado.
   * Si hay pagos pendientes que coinciden con los criterios de filtrado, emite un evento
   * indicando que hay pagos pendientes de tarjeta de crédito para el itinerario actual.
   *
   * @param creditCardData - Un arreglo que contiene los datos de los pagos con tarjeta de crédito.
   * @returns No hay retorno explícito. Sin embargo, la función emite un evento 'paymentCreditCardPending'
   * si hay pagos pendientes de tarjeta de crédito para el itinerario actual.
   */
  private questPaymentCreditCardPending(creditCardData: any[]) {
    // Actualiza la variable 'paymentCreditCards' con los datos recibidos
    let paymentCreditCards = creditCardData;


    // Filtra los pagos que corresponden al ID del itinerario actual
    paymentCreditCards = paymentCreditCards.filter(payment => payment.itinerary_id === this.itinerary.id);
    const payNull: any =  paymentCreditCards.filter(payment => payment.payment_masters_id === null);

    if(paymentCreditCards.length > 0 && payNull.length > 0) {

      let foundMatch: any = false;

      foundMatch = this.foundMatchItemUid(payNull);

      if(!foundMatch) {

        if(this.itinerary.totalPriceByNetReserved > this.amountFilterItineraryId) {
          this.amountFilterItineraryId = this.itinerary.totalPriceByNetReserved - this.amountFilterItineraryId;
          this.creditCardDataPending = paymentCreditCards;
          this.creditCardPayPartial = true;
          this.amountSumCreditCardNullPending(paymentCreditCards);
          this.creditCardPayDetails(this.creditCardDataPending);
          this.step = 3;
        }

      }
    }

    // Filtra los pagos que aún no tienen un ID de maestro de pago asignado
    paymentCreditCards = paymentCreditCards.filter(payment => payment.payment_masters_id === null);
    paymentCreditCards = paymentCreditCards.filter(payment => payment.itinerary_id === this.itinerary.id);
    // paymentCreditCards = paymentCreditCards.filter(payment => payment.status_id === 5);

    if (paymentCreditCards.length > 0 && !this.creditCardPayPartial) {
    this.amountFilterNull = this.amountSumCreditCardPending(paymentCreditCards);
      // Verifica si hay pagos pendientes después del filtrado
      this.creditCardDataPending = paymentCreditCards;
      this.creditCardPending = true;
      this.creditCardPendingDetails(this.creditCardDataPending);
      this.step = 3;
    }
  }

/**
 * Agrega los detalles de una transacción de pago con tarjeta de crédito a this.details si no existen previamente.
 * @param creditCardData Los detalles de la transacción de pago con tarjeta de crédito.
 */
private creditCardPayDetails(creditCardData: any): void {
  // Itera sobre los detalles de la transacción de pago con tarjeta de crédito
  creditCardData[0].details.forEach((element: any) => {
      // Verifica si el elemento ya está en this.details antes de agregarlo
      const exists = this.details.some(detail => detail.id === Number(element.uid));

      // Si el elemento no existe en this.details, lo agrega
      if (!exists) {
          this.details.push({
              category_id: element.category_id,
              id: Number(element.uid),
              feePayment: true,
              amount: this.totalPrice  //totalPrice
          });
      }
  });
}


/**
 * Agrega los detalles de una transacción de tarjeta de crédito pendiente a this.details si no existen previamente.
 * @param creditCardData Los detalles de la transacción de tarjeta de crédito pendiente.
 */
private creditCardPendingDetails(creditCardData: any): void {
  // Itera sobre los detalles de la transacción de tarjeta de crédito pendiente
  creditCardData[0].details.forEach((element: any) => {
      // Verifica si el elemento ya está en this.details antes de agregarlo
      const exists = this.details.some(detail => detail.id === Number(element.uid));

      const item = this.allItems.find(c => c.id === Number(element.uid));

      // Si el elemento no existe en this.details, lo agrega
      if (!exists) {
          this.details.push({
              category_id: element.category_id,
              id: Number(element.uid),
              amount: this.itinerary.totalPriceByNetReserved, //totalPrice
              currency_payment: this.currencyPayment,
              amount_historic_payment: {
                 exchange_rate: parseFloat(Number(this.currencyAgency.rate).toFixed(2)),
                  converted_amounts: {
                    fee: parseFloat(Number(element.fee * this.currencyAgency.rate).toFixed(2)),
                    netPriceAgent: parseFloat(Number(element.netPriceAgent * this.currencyAgency.rate).toFixed(2)),
                    netPriceBooking: parseFloat(Number(element.netPriceBooking * this.currencyAgency.rate).toFixed(2)),
                    taxPrice: parseFloat(Number(element.taxNightsPriceTotal * this.currencyAgency.rate).toFixed(2)),
                    netPriceBookingFreeTax: element.taxNightsPriceTotal > 0 ? parseFloat(Number(element.netPriceBookingFreeTax * this.currencyAgency.rate).toFixed(2)) : parseFloat(Number(element.netPriceBooking * this.currencyAgency.rate).toFixed(2)),
                    netPriceProvider: parseFloat(Number(element.profility.netPriceProvider * this.currencyAgency.rate).toFixed(2)),
                    netPriceCategory: parseFloat(Number(element.profility.netPriceCategory * this.currencyAgency.rate).toFixed(2)),
                    extras: this.getServiceExtrasConverted(element),
                }
              }
          });
      }
  });
}

private amountSumCreditCardNullPending(paymentCreditCards: any) {

  let creditCardPartialNull = paymentCreditCards.filter(c => c.payment_masters_id === null);

   // Crear un conjunto para almacenar los IDs de los elementos en creditCardPartialNull
   const paymentIds = new Set<number>();
   creditCardPartialNull.forEach(payment => {
       paymentIds.add(Number(payment.details[0].uid));
   });

   // Sumar los valores solo para los elementos en this.itineraryItems que tienen un ID coincidente en paymentIds
   this.itinerary.items.forEach(item => {
       if (paymentIds.has(item.id)) {
        this.partialLeftCreditCard += item.optionNightsNetTotalProf;
       }
   });
}

  private amountSumCreditCardPending(paymentCreditCards: any) {
    let amount = 0;
     // Recorrer el array de paymentCreditCards con el fin de sumar los montos de amount para el monto total
      // de pagos pendientes
    paymentCreditCards.forEach((payment: any) => {
      amount += payment.amount;

    });

    return amount;
  }

  private foundMatchItemUid(payNotNull: any): boolean {
    let foundMatch = false;

    // Recorre los elementos de this.itinerary.items
    this.itinerary.items.forEach((item) => {
        // Recorre los objetos en payNotNull.details.uid
        payNotNull.forEach((payment) => {
            // Compara el id del elemento actual de this.itinerary.items con el uid del objeto actual de payNotNull.details.uid
            if (item.id === Number(payment.details[0].uid)) {
                // Si hay una coincidencia, añade el id al array itemArr
                // itemArr.push(item.id); // No parece necesario
                // Verifica si el valor de item.optionNightsNetTotalProf es igual al amount del objeto actual
                if (item.optionNightsNetTotalProf === payment.amount) {
                    foundMatch = true;
                }
            }
        });
    });

    return foundMatch;
}

submitFormRequestBilling(payload: any): void {
  this.payloadBillingRequest = payload[0];
  this.payloadBillingRequestInvalid = false;

}

alertToFee(event: boolean): void {
  this.alertMessagefee = event;
}

feePayment(event:number):void{
  // console.log('tengo el fee seleccionado', event);
  this.selectedFeePayment = event;
}

getFeeMessage(): boolean {
  if(this.allItems && this.allItems.length > 0) {
    return this.allItems.some(item => item.fee > 0);
  }
  return false;
}

currencyPaymentSelected(event: any): void {
  this.currencyPayment = event;
}

/**
* Método para obtener la imagen del logotipo de la agencia.
*
* Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
* Si la imagen no está disponible o es igual a la ruta del archivo de la API,
* retorna una imagen por defecto.
*
* @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
*/
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.routerStorage || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}

totalPricePayment(event: any): void {
  this.totalPaymentPrice = Number(event);
}





}
